export default __webpack_public_path__ + "static/media/Kate 9781408315248.c4aba4eb.jpg";